export const formatNameToFilter = (name) => name.split("-")
  .filter((string, index) => index !== 0 && string).join("-").trim().toUpperCase()
  